const API_URL = window.configuration.apiUrl;

const unconfiguredGatewayFilter = entry => !entry.organization_id || entry.machines.length === 0;

const configuredGatewayFilter = entry => entry.organization_id && entry.machines.length > 0;

export { API_URL, unconfiguredGatewayFilter, configuredGatewayFilter };
